import { Checkbox } from 'antd';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import styled from 'styled-components';

type Props = {
  value?: boolean;
  onChange?: (value: boolean) => void;
  label?: string;
};

const CheckboxGreen = ({ value, onChange, label }: Props) => {
  const handleChange = (e: CheckboxChangeEvent) => {
    onChange?.(e.target.checked);
  };

  return (
    <Container>
      <CheckboxGreenStyled checked={value} onChange={handleChange}>
        <span className='label'>{label}</span>
      </CheckboxGreenStyled>
    </Container>
  );
};

export default CheckboxGreen;

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  .label {
    color: #1d2129;
    font-family: Poppins;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
  }
`;

const CheckboxGreenStyled = styled(Checkbox)`
  &.ant-checkbox-wrapper {
    align-items: center !important;
  }
  &.ant-checkbox-wrapper:hover {
    .ant-checkbox-inner {
      border-color: #86909c !important;
    }
  }
  .ant-checkbox-inner {
    width: 32px !important;
    height: 32px !important;
    border-radius: 3px !important;
  }
  .ant-checkbox-inner:hover {
    border-color: #86909c !important;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background: #2d6772 !important;
    border-color: #2d6772 !important;
  }
  .ant-checkbox-checked:after {
    border: none !important;
  }
  .ant-checkbox-wrapper:not(.ant-checkbox-wrapper-disabled):hover .ant-checkbox-inner,
  .ant-checkbox:not(.ant-checkbox-disabled):hover .ant-checkbox-inner {
    border-color: #86909c !important;
  }

  .ant-checkbox-inner:after {
    width: 9px !important;
    height: 14px !important;
    top: 48% !important;
    inset-inline-start: 30.5% !important;
    border-width: 3px !important;
  }
`;
